<div *ngIf="canSeeValuePropsComponent()">
  <div *ngIf="canAttachPropositions() || (selectedProps$ | async)?.length" class="tw-font-bold tw-mb-2">
    Additional benefits to show on option card:
  </div>

  <div *ngIf="canAttachPropositions()" class="d-flex justify-content-between align-items-end">
    <app-value-props-dropdown
      [valueProps]="remainingOptions$ | async"
      [isLoading]="isLoading$ | async"
      [isEmpty]="!(valuePropositions$ | async)?.length"
      [disabled]="saving"
      (add)="onAddValueProp($event)"
      (addAll)="onAddAll()"
      (removeAll)="onRemoveAll()"
    ></app-value-props-dropdown>

    <div class="actions">
      <button
        *ngIf="!(editMode$ | async)"
        mat-flat-button
        [color]="'primary'"
        [disabled]="!(selectedProps$ | async)?.length"
        class="tw-mr-2 lendio-density-2"
        (click)="onToggleEditMode(true)"
      >
        Edit
      </button>
      <button
        *ngIf="editMode$ | async"
        mat-stroked-button
        [color]="'secondary'"
        class="tw-mr-2 lendio-density-2"
        [disabled]="saving"
        (click)="onToggleEditMode(false)"
      >
        Cancel
      </button>
      <button
        mat-flat-button
        [color]="'primary'"
        [disabled]="!(hasChanges$ | async) || saving"
        class="lendio-density-2"
        (click)="onSave()"
      >
        <mat-progress-spinner
          *ngIf="saving"
          [color]="'primary'"
          [diameter]="20"
          [class]="'tw-mx-2'"
          mode="indeterminate">
        </mat-progress-spinner>
        <span *ngIf="!saving">Save</span>
      </button>
    </div>
  </div>

  <div
    cdkDropList
    cdkDropListOrientation="mixed"
    class="value-props-list d-flex flex-wrap tw-flex-row tw-gap-2 tw-mt-2 -tw-mx-1"
    (cdkDropListDropped)="changeOrder($event)"
  >
    <div
      *ngFor="let valueProp of (selectedProps$ | async); trackBy: valuePropId"
      cdkDrag
      [cdkDragDisabled]="!(editMode$ | async) || saving"
      class="value-prop-item"
      @listAnimation
    >
      <app-value-prop-item
        [valueProp]="valueProp"
        [editMode]="(editMode$ | async) && !saving"
        (remove)="removeValueProp($event)"
      ></app-value-prop-item>
      <div class="drag-placeholder" *cdkDragPlaceholder></div>
    </div>
  </div>
</div>
